import { Component, OnInit, ViewChild } from "@angular/core";
import { BaseUpdateComponent, BaseDataService, DropdownPicklistComponent, InputComponent, NotificationService } from "yt-ng-framework";
import { KomitentObjekat } from "./komitent-objekat";
import { ActivatedRoute } from "@angular/router";
// import { NotificationsService } from "angular2-notifications";
import { TranslateService } from "@ngx-translate/core";
import { Validators } from "@angular/forms";
import { KomitentView } from "../komitent/komitent-view";
// import { ToastrService } from "ngx-toastr";

@Component({
  selector: "yt-komitent-objekat-update",
  templateUrl: "./komitent-objekat-update.component.html"
})
export class KomitentObjekatUpdateComponent
  extends BaseUpdateComponent<KomitentObjekat>
  implements OnInit {
  koristiSifarnikUlica = false;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    
  ) {
    super(
      activatedRoute,
      baseDataService,
      toastrService,
      translateService
    );
  }

  @ViewChild('cmbKomitent', { static: true }) cmbKomitent : DropdownPicklistComponent<KomitentView>;
  @ViewChild('txtNaziv', { static: true }) txtNaziv : InputComponent;

  ngOnInit() {
    this.addValidatorToFc(
      "KomitentID",
      Validators.required,
      "required",
      "KOMITENTOBJEKAT.KOMITENT.VALIDATION.REQUIRED"
    );
    this.addValidatorToFc(
      "NazivObjekta",
      Validators.required,
      "required",
      "KOMITENTOBJEKAT.NAZIVOBJEKTA.VALIDATION.REQUIRED"
    );
    this.addValidatorToFc(
      "NazivObjekta",
      Validators.maxLength(100),
      "maxlength",
      "KOMITENTOBJEKAT.NAZIVOBJEKTA.VALIDATION.MAXLENGTH"
    );
    this.addValidatorToFc(
      "Adresa",
      Validators.required,
      "required",
      "KOMITENTOBJEKAT.ADRESA.VALIDATION.REQUIRED"
    );
    this.addValidatorToFc(
      "Adresa",
      Validators.maxLength(150),
      "maxlength",
      "KOMITENTOBJEKAT.ADRESA.VALIDATION.MAXLENGTH"
    );
    this.addValidatorToFc(
      "Broj",
      Validators.maxLength(10),
      "maxlength",
      "KOMITENTOBJEKAT.BROJ.VALIDATION.MAXLENGTH"
    );
    this.addValidatorToFc(
      "PodBroj",
      Validators.maxLength(10),
      "maxlength",
      "KOMITENTOBJEKAT.PODBROJ.VALIDATION.MAXLENGTH"
    );
    this.addValidatorToFc(
      "MestoID",
      Validators.required,
      "required",
      "KOMITENTOBJEKAT.MESTO.VALIDATION.REQUIRED"
    );

    

  }

  ngAfterViewInit(){
    if (this.ParentProperty) {
      setTimeout(() => {
        this.baseFormGroup.patchValue({ KomitentID: this.ParentProperty.Value });
        this.baseFormGroup.get("KomitentID").disable();
        this.txtNaziv.focus();
      },0)

    }
    else 
      this.cmbKomitent.focus();     
  }
}
